import { render, staticRenderFns } from "./TransferModalComponent.vue?vue&type=template&id=7b0dfb2c"
import script from "./TransferModalComponent.vue?vue&type=script&lang=ts"
export * from "./TransferModalComponent.vue?vue&type=script&lang=ts"
import style0 from "./TransferModalComponent.vue?vue&type=style&index=0&id=7b0dfb2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports